import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTagPills',
  setup(__props) {

const badgesContextual = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/badgesContextual.vue"))
const pillsContextual = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/pillsContextual.vue"))
const numberBadge = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/numberBadge.vue"))
const pillsTags = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/pillsTags.vue"))
const tagsIcons = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/tagsIcons.vue"))
const roundedPills = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/roundedPills.vue"))
const tagsSection = defineAsyncComponent(() => import("@/components/theme/uikits/tag&pills/tagsSection.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      title: "Tag & Pills"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(badgesContextual)),
        _createVNode(_unref(pillsContextual)),
        _createVNode(_unref(numberBadge)),
        _createVNode(_unref(pillsTags)),
        _createVNode(_unref(tagsIcons)),
        _createVNode(_unref(roundedPills)),
        _createVNode(_unref(tagsSection))
      ])
    ])
  ], 64))
}
}

})